import { isServer } from "utils/runtime";

export const userSyncChannel = isServer ? null : new BroadcastChannel("userSync");
